<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          :disabled-search="!canQueue"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onProcessHandler"
          ref="filterRef"
        />
        <queue-report-status
          :queue-report="queueInfo"
          @on-cancel="cancelQueue"
          @on-download="downloadQueueReport"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import AcademicYearServices from '@/services/api/academicyear.api';
import providerApi from '@/services/api/provider.api';
import locationApi from '@/services/api/location.api';
import specialistApi from '@/services/api/specialist.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';
import ROLE from '@/utils/role';
import hubservice from "@/services/api/hub/hubservice.js";
import Vue from "vue";
import QueueReportStatus from "@/views/progress/shared/components/QueueReportStatus.vue";
import queueReportTypes from "@/utils/constants/queueReportTypes";
import queueReportStatus from "@/utils/constants/queueReportStatus";

export default {
  components: {
    QueueReportStatus,
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Seguimiento de Documentos de Referido',
      routes: ['Informes', 'Seguimiento de Documentos de Referido'],
    },
    queueInfo: null,
    model: {
      search: {
        collections: {
          academicYears: [],
          providers: [],
          billingCenters: [],
          specialists: [],
        },
        filters: {
          academicYear: null,
          provider: null,
          billingCenter: null,
          documentType: null,
          specialist: null,
          sie: null,
        },
      },
    },
  }),
  computed: {
    canQueue() {
      return (
        this.queueInfo === null ||
        this.queueInfo.statusId === queueReportStatus.Completed ||
        this.queueInfo.statusId === queueReportStatus.Failed
      );
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          class: 'col-md-2',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          clearable: false,
          error: 'Favor seleccionar un proveedor.',
          validations: 'required',
          class: 'col-md-4',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          disabled:
            this.model.search.collections.providers.length <= 0 ||
            this.model.search.collections.providers.length == 1,
          onChanged: this.onChangeProvider,
        },
        {
          name: 'specialist',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Especialista',
          placeholder: 'Seleccionar',
          clearable: true,
          options: this.model.search.collections.specialists,
          value: this.model.search.filters.specialist,
          class: 'col-md-4',
          disabled: this.model.search.collections.specialists.length <= 1,
        },
        {
          name: 'billingCenter',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'CSEE Facturación',
          placeholder: 'Seleccionar',
          clearable: true,
          class: 'col-md-6',
          options: this.model.search.collections.billingCenters,
          value: this.model.search.filters.billingCenter,
          disabled: this.model.search.collections.billingCenters.length <= 0,
        },
        {
          name: 'sie',
          component: 'CustomInput',
          type: 'text',
          label: 'SIE',
          placeholder: 'Escriba número de SIE',
          clearable: true,
          icon: 'fa fa-search orange-icon',
          class: 'col-md-4',
          leftIcon: true,
          value: this.model.search.filters.sie,
          disabled: this.model.search.filters.sieDisabled,
        },
      ];
    },
  },
  async mounted() {
    this.applyInitProviderRole();
    await this.setFilters();
    const res = await ReportServices.getPreviousGeneratedReport([queueReportTypes.ReportReferralDocumentTrackingExcel])
    this.queueInfo = res.data !== '' ? res.data : null;
  },
  created() {
    Vue.use(hubservice);
    this.$userHub.$on(
      'hub-receive-status-queue-report',
      this.updateReceivedQueueStatusByHub
    );
  },
  beforeDestroy() {
    //clean SignalR event
    this.$userHub.$off(
      'hub-receive-status-queue-report',
      this.updateReceivedQueueStatusByHub
    );
  },
  methods: {
    async onProcessHandler() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      ReportServices.queueReport('referraldocumentstracking', {
        academicYearId: this.model.search.filters.academicYear?.id.toString(),
        studentSieId: this.model.search.filters.sie?.toString(),
        specialistId: this.model.search.filters.specialist?.id.toString(),
        companyId: this.model.search.filters.provider?.id.toString(),
        billingCenterId: this.model.search.filters.billingCenter?.id.toString(),
      }).then((res) => {
        this.queueInfo = {
          executionLogId: res.data,
          statusId: queueReportStatus.Pending,
          expired: false,
        };
      });
    },
    async downloadQueueReport(executionLogId) {
      ReportServices.downloadQueueReport(executionLogId)
        .then((res) => DocumentServices.Download(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async cancelQueue(executionLogId) {
      ReportServices.cancelQueueReport(executionLogId)
        .then((res) => {
          if (res.data) {
            this.ShowToast(
              'Proceso Exitoso',
              'La ejecución del reporte ha sido cancelada exitosamente.',
              'success'
            );
            this.queueInfo = null;
          }
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    updateReceivedQueueStatusByHub(res) {
      this.queueInfo = res.respose;
    },
    applyInitProviderRole() {
      const isProviderRole = this.userRole == ROLE.Provider;
      const hasOnlyOneCompany = this.userCompanies.length == 1;
      if (isProviderRole && hasOnlyOneCompany) {
        this.model.search.filters.provider = this.userCompanies[0];
        this.getSpecialist();
      }

      return isProviderRole && hasOnlyOneCompany;
    },
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears().then(
        (res) => (this.model.search.collections.academicYears = res.data)
      );
    },
    async onChangeAcademicYear() {
      if (!this.applyInitProviderRole()) {
        this.model.search.filters.provider = null;
      }
      this.model.search.collections.providers = [];
      this.model.search.filters.billingCenter = null;
      this.model.search.collections.billingCenters = [];
      this.model.search.filters.specialist = null;
      this.model.search.collections.specialists = [];

      await this.getProvider();
      await this.getBillingCenter();
    },
    async onChangeProvider() {
      this.model.search.filters.specialist = null;
      this.model.search.collections.specialists = [];

      await this.getSpecialist();
    },
    async getProvider() {
      if (this.applyInitProviderRole()) return;

      const res = await providerApi.getAllProvidertCompaniesByYear({
        academicYearId: this.model.search.filters.academicYear?.id,
      });

      const userCompanyIds = this.userCompanies.map((x) => x.id);
      const availableCompanies =
        this.userRole == ROLE.Provider
          ? res.data.filter((x) => userCompanyIds.includes(x.id))
          : res.data;

      this.model.search.collections.providers = availableCompanies;

      if (availableCompanies.length == 1) {
        this.model.search.filters.provider = availableCompanies[0];
        this.getSpecialist();
      }
    },
    async getBillingCenter() {
      await locationApi
        .getBillingCenters({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.billingCenters = res.data;
        });
    },
    async getSpecialist() {
      await specialistApi
        .getSpecialistProvider({
          academicYearId: this.model.search.filters.academicYear?.id,
          companyId: this.model.search.filters.provider?.id,
        })
        .then((res) => {
          this.model.search.collections.specialists = res.data;

          if (res.data.length == 1) {
            this.model.search.filters.specialist = res.data[0];
          }
        });
    },
    hasValue(paramValue) {
      return paramValue !== null && paramValue !== undefined;
    },
  },
};
</script>
